// extracted by mini-css-extract-plugin
export default {"wrap":"LinkMenu_wrap__XTGMh","popover":"LinkMenu_popover__jjQvA","input":"LinkMenu_input__5cRCi","submit":"LinkMenu_submit__Sh4yq"};